import React from 'react';
import { Keys, locale } from 'src/i18n';

// TODO: will implement when figma is finalized
function DocumentPreview() {
  return <div>{locale(Keys.DOCUMENT_PREVIEW)}</div>;
}

export default DocumentPreview;
